export default {
  selectTradAcc: '选择交易账户',
  tradeAccount: '交易账户',
  accountInfo: '账户信息',
  latest_records: '最新记录',
  download: '下载',
  deposit: '存款',
  withdrawal: '取款',
  transfer: '内部转账',
  account_balance: '余额',
  account_equity: '账户权益',
  view_more: '查看更多',
  completed: '完成',
  failure: '失败',
  submitted: '已提交',
  currency: '货币',
  type: '类型',
  accountNo: '账号',
  toAccountNo: '转出账号',
  bankCardNo: '银行卡号',
  noDeposit: '无存款记录',
  noWithdrawal: '无取款记录',
  noFund: '无内部转账记录',
  amount: '总额',
  order_No: '单号：', // 补充
  stock: '证券', // 补充
  futures: '期货', // 补充
  forex: '外汇', // 补充
  pm: '现货黄金', // 补充
  platform: '平台', // 补充
  total_cash: '净现金结余',
  ref_portfolio: '参考投资组合总值',
  stockOptionsCash: '香港股票期权账户(现金)',
  securitiesCash: '香港及环球证券账户(现金)',
  securitiesMargin: '香港及环球证券账户(保证金)',
  securitiesDayTradeMargin: '香港证券即日买卖账户(保证金)',
  futuresMargin: '香港及环球期货账户(保证金)',
  futuresDayTradeMargin: '香港期货即日买卖账户(保证金)',
  interactiveBrokerIntegratedMargin: '盈透证券综合户口(保证金)',
  STOCK: '证券',
  FUTURES: '期货',
  FOREX: '外汇',
  mt5: '(MT5)',
  mf: '(Eddid FX Pro)',
  userStatus_title_one: '填写开户资料',
  userStatus_title_two: '完善开户资料',
  userStatus_title_three: '开户资料审核中',
  userStatus_description_one: '您还未填写开户资料<br>请扫描二维码下载APP完成开户',
  userStatus_description_two: '您的开户资料还未完善<br>请扫描二维码下载APP继续填写',
  userStatus_description_three: '您提交的开户申请正在审核中<br>请扫描二维码查看开户进度',
  yesterdayBalance: '上日结存',
  accountBalance: '账户余额',
  accountInterests: '账户净值',
  dataFail: '数据异常',
  loadingData: '正在加载数据...',
  balance: '当日结存',
  enabled: '账户状态',
  enabled_false: '停用',
  enabled_true: '启用',
  enabled_close: '关闭',
  ib: 'EddidPro',
  dialogTexts: {
    checkedText: '本人已阅读知悉及明白以上协议内容',
    privacy: '客户声明',
    returnLogin: '返回登录',
    confirm: '确定',
    tips: '请阅读及同意协议内容',
    confirmandread: '我已阅读并同意'
  },
  cdd: {
    title: '客户尽职审查',
    context1: '根据香港证监会《打击洗钱及恐怖分子资金筹集指引》，持牌法团需定期为客户进行「客户尽职审查」。',
    context2: '阁下的交易账户已有一段时间没有任何活动，阁下的交易账户将会或已被冻结。 如 阁下仍然想维持其交易账户，请立刻确认阁下最新的个人资料。阁下之个人资料与开户申请时所提交的资料是否相同?',
    context3: '阁下的个人资料与开户申请时所提交的数据是否相同？',
    fileDiffContext: '如阁下个人资料有更新，请尽快联络客服及提交资料更改申请表。'
  }
}
